import { api, extractResponseData } from "./base";

export const getReaderProfileOnboardingConfig = async () => {
  try {
    const response = await api.get("/platform/categories");
    const categories = extractResponseData(response);
    return {
      readingCategories: categories,
      gradeLevels: [
        "ONE",
        "TWO",
        "THREE",
        "FOUR",
        "FIVE",
        "SIX",
        "SEVEN",
        "EIGHT",
        "NINE",
        "TEN",
        "ELEVEN",
        "TWELVE",
      ],
    };
  } catch (error) {
    console.error(
      "Error fetching reader profile onboarding configuration:",
      error,
    );
    throw new Error(`Failed to fetch configuration: ${error.message}`);
  }
};

export const configurationService = {
  getReaderProfileOnboardingConfig,
};
